import { useSevenStore } from '@/modules/seven';
import { useLanguageStore } from '@/common/stores/language';
import type { GravityGetArticleResponse, GravityGetAppResponse, GravityPageResponse } from './types';
import { cfInstance } from './axiosInstance';

const V1_PREFIX = '/v1';

const getGravityAppNameCf = (tenantUuid: string) => cfInstance
  .get<GravityGetAppResponse>(
  `${V1_PREFIX}/terminal/apps/${tenantUuid}?extend=company`,
  {
    headers: {
      'X-Nsft-SCD-Merge': true,
    },
  },
);

const getArticle = (articleName: string) => {
  const sevenStore = useSevenStore();
  const languageStore = useLanguageStore();

  return cfInstance
    .get<GravityGetArticleResponse>(
    `${V1_PREFIX}/terminal/articles/${articleName}`,
    {
      headers: {
        'X-Nsft-SCD-Company-Id': sevenStore.tenant.uuid,
        'X-Nsft-SCD-Locale': languageStore.getCurrentLanguage(),
      },
    },
  );
};

const getPageByName = (pageName: string, appName: string) => {
  const sevenStore = useSevenStore();
  const languageStore = useLanguageStore();

  return cfInstance
    .get<GravityPageResponse>(
    `${V1_PREFIX}/terminal/pages/${pageName}`,
    {
      headers: {
        'X-Nsft-SCD-Company-Id': sevenStore.tenant.uuid,
        'X-Nsft-SCD-Locale': languageStore.getCurrentLanguage(),
        'X-Nsft-SCD-App-Name': appName,
      },
    },
  );
};

const getMenu = (menuName: string, appName: string) => {
  const sevenStore = useSevenStore();
  const languageStore = useLanguageStore();

  return cfInstance
    .get(
      `${V1_PREFIX}/terminal/menus/${menuName}`,
      {
        headers: {
          'X-Nsft-SCD-Company-Id': sevenStore.tenant.uuid,
          'X-Nsft-SCD-Locale': languageStore.getCurrentLanguage(),
          'X-Nsft-SCD-App-Name': appName,
        },
      },
    );
};

export {
  getGravityAppNameCf,
  getArticle,
  getPageByName,
  getMenu,
};
